<template>
  <div class="floating-window-box">
    <ul class="show-flex-box-c">
      <li
        v-for="(item, index) in floatingParams"
        :key="index"
        class="show-flex-box-c"
        @mouseleave="displayNone(item.id)"
        @mouseenter="displayMore(item.id)"
        @click="toTop(item.id)"
        v-if="item.isActive"
      >
        <span class="show-flex-box-r">
          <img
            :src="hoverIndex == item.id ? item.floatImg : item.img"
            alt="新华书店"
            draggable="false"
          />
        </span>
        <strong>{{ item.name }}</strong>
        <div
          class="mars-consult show-flex-box-c"
          v-show="item.slideImg && scanConsult && item.id == 0"
        >
          <div class="mars-consult-limit show-flex-box-c">
            <!-- <a
              class="connect-box show-flex-box-r"
              target="_blank"
              href="https://tb.53kf.com/code/client/3D873DB9CE5B6BAE8FEFF4AC462176844/1"
            >
              <strong class="show-flex-box-r"></strong>
              <h2>在线客服 ></h2>
            </a> -->
            <div class="qrcode-box show-flex-box-c">
              <div class="show-flex-box-r">
                <strong class="show-flex-box-r"></strong>
                <h2>关注我们</h2>
              </div>
              <span class="consult-qr-code show-flex-box-r">
                <img :src="item.slideImg" alt="新华书店" draggable="false" />
              </span>
            </div>
            <div class="phone-box show-flex-box-r">
              <strong class="show-flex-box-r"></strong>
              <h2>联系手机号</h2>
            </div>
          </div>
        </div>
        <div
          class="mars-watch show-flex-box-c"
          v-show="item.slideImg && scanCode && item.id == 1"
        >
          <div class="mars-watch-limit show-flex-box-c">
            <span class="show-flex-box-r">
              <img :src="item.slideImg" alt="新华书店" draggable="false" />
            </span>
            <h1>扫码关注新华书店官方服务号</h1>
          </div>
        </div>
        <!-- <div class="mars-app show-flex-box-c" v-show="item.slideImg && scanApp && item.id == 2">
          <div class="mars-app-limit show-flex-box-c">
            <span class="show-flex-box-r">
              <img :src="item.slideImg" alt="新华书店" draggable="false" />
            </span>
            <h1>扫码下载新华书店APP</h1>
          </div>
        </div> -->
      </li>
    </ul>
    <!-- <div class="slic-box" v-if="curComponentName == 'home'">
      <strong></strong>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "floating_window_cpn",
  props: {},
  data() {
    return {
      floatingParams: [
        {
          id: 0,
          name: "立即咨询",
          img: require("../../assets/common/consult_now_icon.png"),
          floatImg: require("../../assets/common/consult_now_hover_icon.png"),
          slideImg: require("../../assets/common/mars_weixin_img.jpg"),
          isActive: true
        },
        {
          id: 1,
          name: "扫码关注",
          img: require("../../assets/common/scan_code_attention_icon.png"),
          floatImg: require("../../assets/common/scan_code_attention_hover_icon.png"),
          slideImg: require("../../assets/common/mars_weixin_img.jpg"),
          isActive: true
        },
        // {
        //   id: 2,
        //   name: "APP 下载",
        //   img: require("../../assets/common/app_download_icon.png"),
        //   floatImg: require("../../assets/common/app_download_hover_icon.png"),
        //   slideImg: require("../../assets/common/mars_app_icon.png"),
        //   isActive: true
        // },
        // {
        //   id: 3,
        //   name: "意见反馈",
        //   img: require("../../assets/common/user_record_icon.png"),
        //   floatImg: require("../../assets/common/user_record_hover_icon.png"),
        //   slideImg: null
        // },
        {
          id: 4,
          name: "返回顶部",
          img: require("../../assets/common/go_to_top_icon.png"),
          floatImg: require("../../assets/common/go_to_top_hover_icon.png"),
          slideImg: null,
          isActive: true
        }
      ],
      hoverIndex: -1,
      scanCode: false,
      scanApp: false,
      scanConsult: false,
      curComponentName: ""
    };
  },
  mounted() {
    window.addEventListener("scroll", this.showBackTop);
  },
  methods: {
    displayMore: function(id) {
      this.hoverIndex = id;
      if (id == 0) {
        this.scanConsult = true;
        this.scanApp = false;
        this.scanCode = false;
      } else if (id == 1) {
        this.scanCode = true;
        this.scanApp = false;
        this.scanConsult = false;
      } else if (id == 2) {
        this.scanApp = true;
        this.scanCode = false;
        this.scanConsult = false;
      }
    },
    displayNone: function(id) {
      this.hoverIndex = -1;
      if (id == 0) {
        this.scanConsult = false;
        this.scanCode = false;
        this.scanApp = false;
      } else if (id == 1) {
        this.scanConsult = false;
        this.scanCode = false;
        this.scanApp = false;
      } else if (id == 2) {
        this.scanConsult = false;
        this.scanApp = false;
        this.scanCode = false;
      }
    },
    showBackTop: function() {
      let browserH = (document.body.clientHeight * 2) / 3;
      let scrollH = $(document).scrollTop();

      if (!this.floatingParams || !this.floatingParams[3]) {
        return;
      }

      if (scrollH > browserH) {
        this.floatingParams[3].isActive = true;
      } else {
        this.floatingParams[3].isActive = false;
      }
    },
    toTop: function(id) {
      if (id == 4) {
        var body = $("html, body");
        var dur = body.scrollTop() / 3;
        body.stop().animate({ scrollTop: 0 }, dur);
      } else if (id == 3) {
        const { href } = this.$router.resolve({
          path: "/about_us/about_home/feedback",
          query: {}
        });
        // console.log(JSON.stringify(href));
        window.open(href, "_blank");
      }
    },
    configWindowList: function() {
      if (this.curComponentName == "course_detail_list") {
        for (var i = 0; i < this.floatingParams.length; i++) {
          if (i == 0) {
            this.floatingParams[i].isActive = true;
          } else {
            this.floatingParams[i].isActive = false;
          }
        }
      } else {
        for (var i = 0; i < this.floatingParams.length; i++) {
          this.floatingParams[i].isActive = true;
        }
      }
    }
  },
  watch: {
    $route: function(from) {
      this.curComponentName = this.$route.name;
      this.configWindowList();
    }
  }
};
</script>
<style lang="less" scoped>
.floating-window-box {
  position: fixed;
  right: 20px;
  top: 40%;
  width: 64px;
  height: 340px;
  z-index: 9999;
  .slic-box {
    position: fixed;
    right: 0;
    bottom: 10px;
    width: 224px;
    height: 288px;
    padding-top: 50px;
    text-align: center;
    cursor: pointer;
    background: url("../../assets/lice.png") center center no-repeat;
    background-size: 224px 288px;
    z-index: 10;
    & > strong {
      font-size: 16px;
      color: #999;
    }
  }
  & > ul {
    z-index: 20;
    & > li {
      position: relative;
      width: 54px;
      height: 64px;
      align-items: center;
      justify-content: center;
      border: 1px solid #e5e5e5;
      background: #fff;
      border-radius: 5px;
      padding-left: 5px;
      padding-right: 5px;
      margin-bottom: 5px;
      transition: all 0.5s;
      cursor: pointer;
      & > span {
        width: 22px;
        height: 22px;
        margin-bottom: 8px;
        & > img {
          width: 22px;
          height: 22px;
        }
      }
      & > strong {
        display: block;
        color: #191d21;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
      }
      & > .mars-consult {
        position: absolute;
        right: 66px;
        top: 0;
        justify-content: center;
        width: 150px;
        height: 202px;
        padding-right: 3px;
        & > .mars-consult-limit {
          height: 100%;
          padding-left: 12px;
          padding-right: 12px;
          border: 1px solid #ff5100;
          background: #fff;
          border-radius: 5px;
          transition: all 0.5s;
          justify-content: center;
          & > .connect-box {
            width: 100%;
            margin-bottom: 12px;
            align-items: center;
            & > strong {
              width: 15px;
              height: 15px;
              background: url("../../assets/common/connect_float_icon.png")
                no-repeat center center;
              background-size: cover;
              margin-right: 5px;
            }
            & > h2 {
              display: block;
              color: #f38900;
              font-size: 14px;
              font-weight: 400;
              line-height: 15px;
            }
          }
          & > .qrcode-box {
            width: 100%;
            & > div {
              width: 100%;
              margin-bottom: 10px;
              align-items: center;
              & > strong {
                width: 15px;
                height: 15px;
                background: url("../../assets/common/weixin_float_icon.png")
                  no-repeat center center;
                background-size: cover;
                margin-right: 5px;
              }
              & > h2 {
                display: block;
                color: #191d21;
                font-size: 14px;
                font-weight: 400;
                line-height: 15px;
                white-space: nowrap;
              }
            }
            & > .consult-qr-code {
              width: 83px;
              height: 83px;
              margin-bottom: 1px;
              margin-left: 22px;
              & > img {
                width: 83px;
                height: 83px;
              }
            }
          }
          & > .phone-box {
            width: 100%;
            margin-top: 12px;
            align-items: center;
            & > strong {
              width: 15px;
              height: 15px;
              background: url("../../assets/common/phone_float_icon.png")
                no-repeat center center;
              background-size: cover;
              margin-right: 5px;
            }
            & > h2 {
              display: block;
              color: #191d21;
              font-size: 14px;
              font-weight: 400;
              line-height: 15px;
              white-space: nowrap;
            }
          }
        }
      }
      & > .mars-watch {
        position: absolute;
        right: 66px;
        top: 0;
        justify-content: center;
        align-items: center;
        width: 150px;
        height: 130px;
        padding-right: 3px;
        & > .mars-watch-limit {
          height: 100%;
          border: 1px solid #ff5100;
          background: #fff;
          border-radius: 5px;
          transition: all 0.5s;
          justify-content: center;
          align-items: center;
          padding-left: 12px;
          padding-right: 12px;
          & > span {
            width: 89px;
            height: 89px;
            margin-bottom: 1px;
            & > img {
              width: 89px;
              height: 89px;
            }
          }
          & > h1 {
            display: block;
            color: #191d21;
            font-size: 14px;
            font-weight: 500;
            word-break: break-all;
            text-align: center;
          }
        }
      }
      & > .mars-app {
        position: absolute;
        right: 66px;
        top: 0;
        justify-content: center;
        align-items: center;
        width: 150px;
        height: 130px;
        padding-right: 3px;
        & > .mars-app-limit {
          height: 100%;
          padding-left: 12px;
          padding-right: 12px;
          border: 1px solid #ff5100;
          background: #fff;
          border-radius: 5px;
          transition: all 0.5s;
          justify-content: center;
          align-items: center;
          & > span {
            width: 89px;
            height: 89px;
            margin-bottom: 1px;
            & > img {
              width: 89px;
              height: 89px;
            }
          }
          & > h1 {
            display: block;
            color: #191d21;
            font-size: 14px;
            font-weight: 500;
            // word-break: break-all;
            text-align: center;
          }
        }
      }
    }
    & > li:hover {
      border: 1px solid #ff5100;
      background: #ff5100;
      & > strong {
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/floating_window_cpn.vue